export default __webpack_public_path__ + "static/media/laundry2-afterB-1920w.5a1d7617.avif";